<template>


    <base-cta-list
        title="Sajter"
        subtitle="Här finner du tillgängliga sajter"
        :headers="headers"
        storeNamespace="settings"
        listNamespace="A_site"
        :icon="logo"
        buttonText="Ny sajt"
        :changePathOnEdit="true"
        editPath="site"
    >

         <template #dialog-content="{setDialog, dataId}"> 
             <site-form
                :listOnSave="true"
                @requestIsDone="setDialog(false)"
                :id="dataId"
             ></site-form>
         </template>

    </base-cta-list>



</template>

<script>
import SiteForm from '../components/SiteForm.vue'


export default {
    name: "Sites",
    metaInfo: {
        title: 'Sites'
    },
    components: {
        SiteForm,
    },
    data() {
      return {
        headers: [
            {
                text: 'Name',
                align: 'start',
                sortable: true,
                value: 'name'
            }
        ],
        logo: require('@/assets/images/svg/skycraper.svg')
      }
    },
}
</script>

<style>

</style>